var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_linear_114_29616)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 10.8125H35.1875V23.8125H32.75V10.8125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.125 23.8125V12.4375H28.6875V20.0072C28.7606 20.0774 28.8305 20.151 28.8996 20.2257C28.9256 20.2537 28.9512 20.2818 28.9763 20.3102C29.2022 20.5645 29.4033 20.84 29.5772 21.1341C29.5817 21.1414 29.5861 21.1483 29.5902 21.1556C29.6499 21.2576 29.7056 21.3616 29.758 21.468C29.7604 21.4733 29.7628 21.4786 29.7657 21.4839C30.1126 22.1871 30.3125 22.9756 30.3125 23.8125H31.125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8631 29.0938H24.7932C24.5312 29.0938 24.285 29.1957 24.0997 29.381C23.9145 29.5662 23.8125 29.8128 23.8125 30.0744V30.5506L24.8817 31.6198L25.5886 30.8423C25.7532 30.6615 25.8438 30.4271 25.8438 30.1825V30.0744C25.8438 29.5337 25.4038 29.0938 24.8631 29.0938Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3473 31.2338L21.9218 32.1251C20.8428 32.7994 19.6001 33.1557 18.3281 33.1557C16.5171 33.1557 14.8141 32.4505 13.5332 31.1696L13.369 31.0054L13.9439 30.431L14.108 30.5951C15.2626 31.7497 16.8104 32.3749 18.4451 32.342C18.2115 30.8994 17.5148 29.5982 16.4984 28.6069L15.1781 30.2892L13.8269 27.1367C12.288 27.5576 11.2188 28.949 11.2188 30.5513C11.2188 31.573 11.6595 32.5447 12.4286 33.2175C13.5803 34.2258 15.0582 34.7807 16.589 34.7807H17.7939C20.2196 34.7807 22.5539 33.8459 24.311 32.1974L23.3473 31.2338Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 24.77V23.5744L13.2008 23.119C12.9705 22.8891 12.8438 22.5828 12.8438 22.257V22.1875C12.8438 21.6578 13.1834 21.206 13.6562 21.0382V20.5625C13.6562 19.6663 14.3851 18.9375 15.2812 18.9375V19.75C14.8332 19.75 14.4688 20.1144 14.4688 20.5625V21.7812H14.0625C13.8387 21.7812 13.6562 21.9637 13.6562 22.1875V22.257C13.6562 22.3654 13.6985 22.4678 13.7753 22.5446L14.4688 23.2381V26.3747C15.0501 26.5941 15.5957 26.8785 16.0938 27.2234V25.8442L16.0942 25.0312L16.7381 25.0317C17.0001 25.0317 17.2459 24.9297 17.4311 24.7444C17.6168 24.5592 17.7188 24.3126 17.7188 24.0506V22.7075L18.9148 22.309C18.8372 21.7817 18.5646 21.0463 18.1278 20.1944C17.9873 19.9202 17.7098 19.75 17.4031 19.75H17.3125V18.9375H17.4031H18.3281C19.1122 18.9375 19.75 18.2997 19.75 17.5156C19.75 16.7316 19.1122 16.0938 18.3281 16.0938H15.8342C13.2894 16.0938 11.2188 18.1644 11.2188 20.7092C11.2188 22.4239 12.1519 23.9644 13.6562 24.77ZM16.5 18.5312C16.5 19.2873 16.6946 19.776 17.1935 20.2753L16.619 20.8497C15.9662 20.1969 15.6875 19.5034 15.6875 18.5312H16.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8823 28.0742C15.5548 27.8244 15.2038 27.6022 14.8301 27.4141L15.385 28.7084L15.8823 28.0742Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 33.3525V33.9688C24.2188 34.4169 24.5832 34.7813 25.0312 34.7813C25.4793 34.7813 25.8438 34.4169 25.8438 33.9688V31.7698L25.4432 32.2102C25.065 32.6266 24.6547 33.0072 24.2188 33.3525Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 19.3438C22.5673 19.3438 20.5625 21.3486 20.5625 23.8125C20.5625 26.2764 22.5673 28.2812 25.0312 28.2812C27.4952 28.2812 29.5 26.2764 29.5 23.8125C29.5 21.3486 27.4952 19.3438 25.0312 19.3438ZM25.0312 27.0625C23.2364 27.0625 21.7812 25.6073 21.7812 23.8125C21.7812 22.0177 23.2364 20.5625 25.0312 20.5625C26.8261 20.5625 28.2812 22.0177 28.2812 23.8125C28.2812 25.6073 26.8261 27.0625 25.0312 27.0625Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0625 18.9375V14.875H24.625V18.552C24.7595 18.5414 24.8939 18.5312 25.0312 18.5312C25.7511 18.5312 26.4369 18.6763 27.0625 18.9375Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2812 29.9062H29.0938V30.7188H28.2812V29.9062Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9062 29.9062H34.7812V30.7188H29.9062V29.9062Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2812 31.5312H29.0938V32.3438H28.2812V31.5312Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9062 31.5312H34.7812V32.3438H29.9062V31.5312Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2812 33.1562H29.0938V33.9688H28.2812V33.1562Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9062 33.1562H34.7812V33.9688H29.9062V33.1562Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_29616",
    x1: 23,
    y1: 26.895,
    x2: 23,
    y2: 0.992272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050D42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.30921fb045473d78b51deb3c0a231121.svg";
export { ForwardRef as ReactComponent };